import { useState } from "react";
import { useMediaQuery } from "@hooks/useMediaQuery";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { localizedDate } from "@utils/utils";
import { useStore } from "@hooks/useZustandProvider";
import { useQuery } from "@apollo/client";
import Loading from "@ui-kit/Loading/Loading";
import Button from "@ui-kit/Button/Button";
import Container from "@ui-kit/Container/Container";
import { GET_ALL_PAGES_USER } from "@api/queriesV2/cms";
import { getPageFolderName, getPageTypes } from "@config/cms";
import s from "./LatestHeroBlock.module.scss";


const LatestHeroBlock = ({ data, settings }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { isMobile } = useMediaQuery();
  const { getBlockLocale } = useStore();
  const { contentType } = settings.specific;
  const [first, setFirst] = useState(null)

  const lang = getBlockLocale(locale);

  const desktopImage = first?.data?.pageData?.blocks?.[0]?.data?.blockBackgroundImage;
  const mobileImage = first?.data?.pageData?.blocks?.[0]?.data?.blockBackgroundImageMobile;

  const background =
    desktopImage || mobileImage
      ? `linear-gradient(90deg, #000000d9, transparent), url(${isMobile
        ? mobileImage || desktopImage
        : desktopImage
      })`
      : `linear-gradient(90deg, #000000d9, transparent)`;

  const { loading, error, data: pagesData } = useQuery(GET_ALL_PAGES_USER, {
    variables: {
      language: lang,
      type: getPageTypes()[contentType.value]
    },
    fetchPolicy: "cache-and-network",
    context: { clientName: "v2" },
    onCompleted: (data) => {
      const pages = data.getAllPagesUser.filter(i => !!i.data);

      const filteredPages = pages.sort((a, b) => (
        new Date(b.properties.datePublished) - new Date(a.properties.datePublished)
      ));

      filteredPages[0] && setFirst(filteredPages[0])
    },
  });

  return (
    <Container
      className={s.container}
      style={{
        backgroundImage: background,
      }}
    >
      <Container
        full={false}
        className={s.innerContainer}
      >
        {loading ? (
          <Loading />
        ) : (
          first ? (
            <>
              <time className={s.date} dateTime={first.properties.datePublished}>
                {localizedDate(first.properties.datePublished, "dd MMMM yyyy", locale)}
              </time>
              <h2>{first.data.seo.title}</h2>
              <Button
                className={s.button}
                text={t("read more")}
                to={`/${getPageFolderName()[contentType.value]}/${first.data.slug}`}
              />
            </>
          ) : (
            <p>No one published {contentType.value}</p>
          )
        )}
      </Container>
    </Container>
  );
};

export default LatestHeroBlock;